
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/privacy-policy-know-your-rights",
      function () {
        return require("private-next-pages/privacy-policy-know-your-rights.tsx");
      }
    ]);
  